// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "new-cooperated-form",
  formField: {
    full_name: {
      name: "full_name",
      label: "Nome Completo",
      type: "text",
      errorMsg: "O Nome completo é obrigatório",
      invalidMsg: "Nome completo inválido",
    },
    social_name: {
      name: "social_name",
      label: "Nome social",
      type: "text",
    },
    cpf: {
      name: "cpf",
      label: "CPF",
      type: "text",
      errorMsg: "O CPF é obrigatório",
      invalidMsg: "CPF inválido",
    },
    pa_id: {
      name: "pa_id",
      label: "PA",
      type: "text",
      errorMsg: "O PA é obrigatório",
      invalidMsg: "PA inválido",
    },
    status: {
      name: "status",
      label: "Status",
      type: "text",
      errorMsg: "O Status é obrigatório",
      invalidMsg: "Status inválido",
    },
    birth_date: {
      name: "birth_date",
      label: "Data de Nascimento",
      type: "text",
      errorMsg: "A Data de Nascimento é obrigatória",
      invalidMsg: "Data de Nascimento inválida",
    },
    document_number: {
      name: "document_number",
      label: "Número do Documento",
      type: "text",
      errorMsg: "O Número do Documento é obrigatório",
      invalidMsg: "Número do Documento inválido",
    },
    issuing_body: {
      name: "issuing_body",
      label: "Órgão Emissor",
      type: "text",
      errorMsg: "O Órgão Emissor é obrigatório",
      invalidMsg: "Órgão Emissor inválido",
    },
    document_uf: {
      name: "document_uf",
      label: "UF",
      type: "text",
      errorMsg: "O UF é obrigatório",
      invalidMsg: "UF inválido",
    },
    issue_date: {
      name: "issue_date",
      label: "Data de Emissão",
      type: "text",
      errorMsg: "A Data de Emissão é obrigatória",
      invalidMsg: "Data de Emissão inválida",
    },
    nationality: {
      name: "nationality",
      label: "Nacionalidade",
      type: "text",
      errorMsg: "A Nacionalidade é obrigatória",
      invalidMsg: "Nacionalidade inválida",
    },
    birth_city: {
      name: "birth_city",
      label: "Cidade de Nascimento",
      type: "text",
      errorMsg: "A Cidade de Nascimento é obrigatória",
      invalidMsg: "Cidade de Nascimento inválida",
    },
    birth_uf: {
      name: "birth_uf",
      label: "UF de Nascimento",
      type: "text",
      errorMsg: "O UF de Nascimento é obrigatório",
      invalidMsg: "UF de Nascimento inválido",
    },
    mothers_name: {
      name: "mothers_name",
      label: "Nome da Mãe",
      type: "text",
      errorMsg: "O Nome da Mãe é obrigatório",
      invalidMsg: "Nome da Mãe inválido",
    },
    fathers_name: {
      name: "fathers_name",
      label: "Nome do Pai",
      type: "text",
    },
    email: {
      name: "email",
      label: "E-mail",
      type: "text",
      errorMsg: "O E-mail é obrigatório",
      invalidMsg: "E-mail inválido",
    },
    phone: {
      name: "phone",
      label: "Celular",
      type: "text",
      errorMsg: "O Celular é obrigatório",
      invalidMsg: "Celular inválido",
    },
    contact: {
      name: "contact",
      label: "Forma de Contato",
      type: "text",
      errorMsg: "O Forma de Contato é obrigatório",
      invalidMsg: "Forma de Contato inválido",
    },
    cep: {
      name: "cep",
      label: "CEP",
      type: "text",
      errorMsg: "O CEP é obrigatório",
      invalidMsg: "CEP inválido",
    },
    street: {
      name: "street",
      label: "Rua",
      type: "text",
      errorMsg: "A Rua é obrigatória",
      invalidMsg: "Rua inválida",
    },
    number: {
      name: "number",
      label: "Número",
      type: "text",
      errorMsg: "O Número é obrigatório",
      invalidMsg: "Número inválido",
    },
    state: {
      name: "state",
      label: "UF",
      type: "text",
      errorMsg: "O UF é obrigatório",
      invalidMsg: "UF inválido",
    },
    complement: {
      name: "complement",
      label: "Complemento",
      type: "text",
    },
    neighborhood: {
      name: "neighborhood",
      label: "Bairro",
      type: "text",
      errorMsg: "O Bairro é obrigatório",
      invalidMsg: "Bairro inválido",
    },
    city: {
      name: "city",
      label: "Cidade",
      type: "text",
      errorMsg: "A Cidade é obrigatória",
      invalidMsg: "Cidade inválida",
    },
    mailing_address: {
      name: "mailing_address",
      label: "Endereço de Correspondência",
      type: "text",
      errorMsg: "O Endereço de Correspondência é obrigatório",
      invalidMsg: "Endereço de Correspondência inválido",
    },
    income: {
      name: "income",
      label: "Renda",
      type: "text",
      errorMsg: "A Renda é obrigatória",
      invalidMsg: "Renda inválida",
    },
    contact_type: {
      name: "contact_type",
      label: "Tipo de contato",
      type: "text",
      errorMsg: "O Tipo de contato é obrigatório",
      invalidMsg: "Tipo de contato inválido",
    },
    gender: {
      name: "gender",
      label: "Gênero",
      type: "text",
      errorMsg: "O Gênero é obrigatório",
      invalidMsg: "Gênero inválido",
    },
    document_type: {
      name: "document_type",
      label: "Tipo de documento",
      type: "text",
      errorMsg: "O Tipo de documento é obrigatório",
      invalidMsg: "Tipo de documento inválido",
    },
    private_description: {
      name: "private_description",
      label: "Descrição Privada",
      type: "text",
    },
    account_number: {
      name: "account_number",
      label: "Número da Conta",
      type: "text",
    },
    situation_document: {
      name: "situation_document",
      label: "Situação CPF",
      type: "text",
    },
    reason_reprovation: {
      name: "reason_reprovation",
      label: "Motivo da reprovação",
      type: "text",
    },
    hiring_type: {
      name: "hiring_type",
      label: "Descrição Privada",
      type: "text",
      invalidMsg: "Descrição privada inválida",
    },
    responsible_email: {
      name: "responsible_email",
      label: "Descrição Privada",
      type: "text",
      invalidMsg: "Descrição privada inválida",
    },
  },
};
